// extracted by mini-css-extract-plugin
module.exports = {"btn_primary":"Buttonprimary_btn_primary__d8tlj"};